
import Qrcode from 'vux/src/components/qrcode/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'


export default{
data () {
return {
qrcode: '',
deposit_type: '',
totalTime: 90,
content: '90',
platform_id: null
}
},
mounted () {
var self = this
self.qrcode = self.$router.currentRoute.query.qrcode
self.platform_id = self.$router.currentRoute.query.platform_id
self.deposit_type = self.$router.currentRoute.query.deposit_type
this.countDown()
},
components: {
Qrcode,
XHeader,
Box,
XButton,
ViewBox
},
methods: {
clickBack () {
var self = this
self.$router.replace({
path: self.$router.currentRoute.query.from_url
})
},
countDown () {
let clock = window.setInterval(() => {
this.totalTime--
this.content = this.totalTime
if (this.totalTime < 1) {     // 当倒计时小于0时清除定时器
window.clearInterval(clock)
}
}, 1000)
}
}
}



// WEBPACK FOOTER //
// ./src/components/Qrcode.vue